export default {
  TODAY: 'today',
  UPCOMING: 'upcoming',
  PENDING: 'pending',
  UPCOMING_EVENTS: 'upcomingEvents',
  ARCHIVED: 'archived'
};
